import React, { useState } from 'react';
import { Dialog, DialogContent, IconButton, DialogTitle } from '@mui/material';
import { useStylesDialogServiceCall } from './style';
import { TableComponents, Icons } from 'components';
import ServiceCallService from '../index';
import axios from 'axios';

const columns = [
  {
    title: 'شناسه مجموعه سرویس',
    field: 'serviceSetId',
    align: 'center',
    filtering: false,
  },
  {
    title: 'نام مجموعه سرویس',
    field: 'serviceSetName',
    align: 'center',
    filtering: false,
  },
];

const DialogServiceCall = ({ open, onClose, serviceSetId }) => {
  const classes = useStylesDialogServiceCall();
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const getServiceSetCall = async (query) => {
    try {
      const params = {
        size: 10,
        page: 0,
      };

      const dataServices = {
        filterVOS: [],
        parentParams: [
          {
            fill: 'BY_BUSINESS_OR_PARENT',
            id: 832,
            key: 'webservices_id',
            order: 0,
            type: 'DECIMAL',
            validValueType: 'NONE',
            value: serviceSetId,
          },
        ],
        orderByElementVOS: [],
      };
      const result = await ServiceCallService.reportWebService(params, dataServices);
      const data = result.data.result.rows.map((row, key) => ({
        serviceSetId: row.cols[0],
        serviceSetName: row.cols[1],
      }));
      setIsLoading(false);
      return {
        data,
        page: query ? query?.pageNumber : page,
        totalCount: result.data.result.totalCount,
      };
    } catch (e) {
      if (axios.isCancel(error)) {
        setIsLoading(true);
      } else {
        setIsLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  return (
    <>
      <Dialog
        onClose={onClose}
        aria-labelledby="simple-dialog-title"
        fullWidth
        maxWidth="md"
        open={open}
        className={classes.dialogMain}
      >
        <DialogTitle id="customized-dialog-title" onClose={onClose} className={classes.title}>
          لیست مجموعه سرویس
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            size="large">
            <Icons icon='Close' color="#939393" size="20" />
          </IconButton>
        </DialogTitle>
        <DialogContent className={classes.dialog}>
          <TableComponents
            isLoading={isLoading}
            data={getServiceSetCall}
            columns={columns}
            onChange={(ps) => {
              setPage(ps?.pageNumber);
              return getServiceSetCall(ps);
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default DialogServiceCall;
